import styled from 'styled-components'
import theme from '../../ui/theme'

export const Title = styled.h2`
  font-size: 12px;
`

export const FileIcon = styled.span`
  color: ${theme.colors.status_alert};
  font-size: 12px;
  margin-right: 8px;
`

export const FileTitle = styled.span`
  color: ${theme.colors.neutral_white};
  font-size: 12px;
`

export const Button = styled.button`
  background: 0;
  color: ${theme.colors.neutral_white};
  font-size: 12px;
`